import {
  BlueprintAnnotatedApi,
  BlueprintInfo,
  BlueprintMinimalInfo,
} from "../api/Blueprints";
import { buildMockPromise } from "../api/helpers";
import { REPORT_TYPES } from "../api/Reports";

export const blueprintsAnnotatedList: BlueprintAnnotatedApi[] = [
  {
    external_id: "b13d017f-01dc-48e8-ab5b-f59efc6cf353",
    workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
    name: "express-check",
    is_active: false,
    is_template: true,
    is_root: true,
    lookback: 1,
    sla_hours: 11,
    copied_from: -1,
    item_types: [
      {
        external_id: "d27fa6c5-611b-4703-9b69-c6e5c2656121",
        item_type_uuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "string1",
        is_active: false,
      },
    ],
    sources: [],
    workflow_steps: [
      {
        id: 0,
        external_id: "f726480d-91d0-4e1f-b848-3e77d8a87ce8",
        created_at: "2022-05-20T23:38:11",
        modified_at: "2022-05-20T23:38:11",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "582e0bb7-e160-4e06-af27-dff1eb521280",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "PersonScrape1",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 2,
        external_id: "862d3897-a785-438e-841e-a6dcdde9755b",
        created_at: "2022-05-20T23:38:11",
        modified_at: "2022-05-20T23:38:11",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "ba89df0f-b49d-48ff-a529-e05544b1f1cb",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "ModelPredict",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 3,
        external_id: "1cb8b648-4d39-4c4f-8be1-4143d407bfc3",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "e802707e-dbf0-4f02-9160-aff1dd7b27fe",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "AutoRate",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 4,
        external_id: "ab44a1d2-2ee8-4a3e-88dc-0e54df0bb55e",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "30ed8a52-bce9-4e5d-886c-0f25027ee603",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "ManualRate",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 5,
        external_id: "5e3816d2-a3e0-47c2-8a49-99aac9e46c1c",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "48e5d039-daa7-467b-85de-e8612b4e0866",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "PersonEnrichment",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 6,
        external_id: "48818b6e-fcb2-4e22-8c00-0c66c308186a",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "f83eebe7-bb2f-4c83-bbe6-e04fa813fa80",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "ProfilePostScrape",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 7,
        external_id: "31667e01-8d19-4223-9542-742cd7539f23",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "e4e3a055-5308-4f13-99af-5a7ade5f9366",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "ModelPredict2",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 8,
        external_id: "c3a90ee9-df9c-478b-9538-34487774e413",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "de79c80b-db15-4ddb-91d7-d86a570f3784",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "PostsAutoRate",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 9,
        external_id: "7afbf110-9a9a-406d-89fd-a7dbdd313cc8",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "fe772a28-cf77-47a8-9d7a-f4f99ba8feb2",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "PostManualRate",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 10,
        external_id: "2c5cddbf-c924-48c4-86e1-f7aabdca4afd",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "8afcc75a-1041-4da2-8aee-948b16f2ab88",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "FinalReportQA",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 11,
        external_id: "f009a3a0-d1f6-487e-8407-c11300a1fa2b",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "c0a09aa9-f67a-4b60-9bd1-8682e178ed36",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "PDFGeneration",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 12,
        external_id: "f9fa2dfc-d00f-4ca8-af19-ad2fe4778b9a",
        created_at: "2022-06-21T07:01:43",
        modified_at: "2022-06-21T07:01:43",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        workflow_step_config_uuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "string",
        is_active: false,
        is_fixed: false,
      },
    ],
    behaviors: [
      {
        external_id: "74504196-439e-441a-a3ba-b5b22342c609",
        name: "HARASSMENT",
        is_active: false,
        media: "TEXT",
      },
      {
        external_id: "8a8733b9-dc6a-43b8-b888-38080f12b7de",

        name: "INTOLERANCE",
        is_active: true,
        media: "TEXT",
      },
      {
        external_id: "80cbaa79-6e72-48e3-97ea-74758891e6eb",

        name: "SEX",
        is_active: true,
        media: "TEXT",
      },
    ],
    keyword_groups: [
      {
        id: 1,
        external_id: "63be2be1-e6f8-42ca-8c55-a31c19550891",
        created_at: "2022-06-21T18:02:10",
        modified_at: "2022-06-21T18:02:10",
        is_deleted: false,
        blueprint_id: 1,
        description: "",
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "string1",
        is_active: false,
        is_fixed: false,
        keywords: [
          {
            id: 1,
            external_id: "033fbbf9-d9c3-46da-9f5d-dbc7af6ce107",
            created_at: "2022-06-21T18:02:59",
            modified_at: "2022-06-21T18:02:59",
            is_deleted: false,
            keyword_group_id: 1,
            modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            value: "string1",
            is_fuzzy: true,
          },
        ],
      },
      {
        id: 2,
        external_id: "cd84e0e1-7fc2-4e47-88c0-f6843aeb1816",
        created_at: "2022-06-21T18:02:12",
        modified_at: "2022-06-21T18:02:12",
        is_deleted: false,
        blueprint_id: 1,
        description: "",
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "string2",
        is_active: false,
        is_fixed: false,
        keywords: [
          {
            id: 2,
            external_id: "3e286a2b-783d-4a3d-8eb0-7e8912db3e4c",
            created_at: "2022-06-21T18:03:29",
            modified_at: "2022-06-21T18:03:29",
            is_deleted: false,
            keyword_group_id: 2,
            modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            value: "string2",
            is_fuzzy: true,
          },
        ],
      },
    ],
  },
  {
    external_id: "b23d017f-01dc-48e8-ab5b-f59efc6cf353",
    workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
    name: "core",
    is_active: false,
    is_template: true,
    is_root: true,
    copied_from: -1,
    lookback: 1,
    sla_hours: 11,
    item_types: [
      {
        external_id: "d27fa6c5-611b-4703-9b69-c6e5c2656121",
        item_type_uuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "string1",
        is_active: false,
      },
    ],
    sources: [],
    workflow_steps: [
      {
        id: 0,
        external_id: "f726480d-91d0-4e1f-b848-3e77d8a87ce8",
        created_at: "2022-05-20T23:38:11",
        modified_at: "2022-05-20T23:38:11",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "582e0bb7-e160-4e06-af27-dff1eb521280",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "PersonScrape1",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 2,
        external_id: "862d3897-a785-438e-841e-a6dcdde9755b",
        created_at: "2022-05-20T23:38:11",
        modified_at: "2022-05-20T23:38:11",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "ba89df0f-b49d-48ff-a529-e05544b1f1cb",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "ModelPredict",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 3,
        external_id: "1cb8b648-4d39-4c4f-8be1-4143d407bfc3",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "e802707e-dbf0-4f02-9160-aff1dd7b27fe",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "AutoRate",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 4,
        external_id: "ab44a1d2-2ee8-4a3e-88dc-0e54df0bb55e",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "30ed8a52-bce9-4e5d-886c-0f25027ee603",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "ManualRate",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 5,
        external_id: "5e3816d2-a3e0-47c2-8a49-99aac9e46c1c",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "48e5d039-daa7-467b-85de-e8612b4e0866",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "PersonEnrichment",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 6,
        external_id: "48818b6e-fcb2-4e22-8c00-0c66c308186a",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "f83eebe7-bb2f-4c83-bbe6-e04fa813fa80",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "ProfilePostScrape",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 7,
        external_id: "31667e01-8d19-4223-9542-742cd7539f23",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "e4e3a055-5308-4f13-99af-5a7ade5f9366",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "ModelPredict2",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 8,
        external_id: "c3a90ee9-df9c-478b-9538-34487774e413",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "de79c80b-db15-4ddb-91d7-d86a570f3784",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "PostsAutoRate",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 9,
        external_id: "7afbf110-9a9a-406d-89fd-a7dbdd313cc8",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "fe772a28-cf77-47a8-9d7a-f4f99ba8feb2",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "PostManualRate",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 10,
        external_id: "2c5cddbf-c924-48c4-86e1-f7aabdca4afd",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "8afcc75a-1041-4da2-8aee-948b16f2ab88",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "FinalReportQA",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 11,
        external_id: "f009a3a0-d1f6-487e-8407-c11300a1fa2b",
        created_at: "2022-05-20T23:38:12",
        modified_at: "2022-05-20T23:38:12",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
        workflow_step_config_uuid: "c0a09aa9-f67a-4b60-9bd1-8682e178ed36",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "PDFGeneration",
        is_active: true,
        is_fixed: true,
      },
      {
        id: 12,
        external_id: "f9fa2dfc-d00f-4ca8-af19-ad2fe4778b9a",
        created_at: "2022-06-21T07:01:43",
        modified_at: "2022-06-21T07:01:43",
        is_deleted: false,
        blueprint_id: 1,
        workflow_config_uuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        workflow_step_config_uuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        shouldPass: true,
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "string",
        is_active: false,
        is_fixed: false,
      },
    ],
    behaviors: [
      {
        external_id: "74504196-439e-441a-a3ba-b5b22342c609",
        name: "HARASSMENT",
        is_active: false,
        media: "TEXT",
      },
      {
        external_id: "8a8733b9-dc6a-43b8-b888-38080f12b7de",

        name: "INTOLERANCE",
        is_active: true,
        media: "TEXT",
      },
      {
        external_id: "80cbaa79-6e72-48e3-97ea-74758891e6eb",

        name: "SEX",
        is_active: true,
        media: "TEXT",
      },
    ],
    keyword_groups: [
      {
        id: 1,
        external_id: "63be2be1-e6f8-42ca-8c55-a31c19550891",
        created_at: "2022-06-21T18:02:10",
        modified_at: "2022-06-21T18:02:10",
        is_deleted: false,
        blueprint_id: 1,
        description: "",
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "string1",
        is_active: false,
        is_fixed: false,
        keywords: [
          {
            id: 1,
            external_id: "033fbbf9-d9c3-46da-9f5d-dbc7af6ce107",
            created_at: "2022-06-21T18:02:59",
            modified_at: "2022-06-21T18:02:59",
            is_deleted: false,
            keyword_group_id: 1,
            modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            value: "string1",
            is_fuzzy: true,
          },
        ],
      },
      {
        id: 2,
        external_id: "cd84e0e1-7fc2-4e47-88c0-f6843aeb1816",
        created_at: "2022-06-21T18:02:12",
        modified_at: "2022-06-21T18:02:12",
        is_deleted: false,
        blueprint_id: 1,
        description: "",
        modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "string2",
        is_active: false,
        is_fixed: false,
        keywords: [
          {
            id: 2,
            external_id: "3e286a2b-783d-4a3d-8eb0-7e8912db3e4c",
            created_at: "2022-06-21T18:03:29",
            modified_at: "2022-06-21T18:03:29",
            is_deleted: false,
            keyword_group_id: 2,
            modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            value: "string2",
            is_fuzzy: true,
          },
        ],
      },
    ],
  },
];

export const workflowsBlueprintsList: BlueprintInfo[] = [
  {
    workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
    name: "Express Workflow",
    lookback: 48,
    sla_hours: 12,
    sources: [
      {
        blueprintItemSource_uuid: "bluee1-item-sour-9fa4-db4b17fdbf60",
        item_source_uuid: "itemsou1-4408-44ec-9fa4-db4b17fdbf60",
        name: "Social Media",
        isActive: false,
      },
    ],
    item_types: [
      {
        blueprintItemType_uuid: "bluee1-item-type-9fa4-db4b17fdbf60",
        item_type_uuid: "itemtype1-4408-44ec-9fa4-db4b17fdbf60",
        name: "Confluence",
        isActive: false,
      },
    ],
    behaviors: [
      {
        behavior_uuid: "beha1f-4408-44ec-9fa4-db4b17fdbf60",
        name: "Community",
        is_active: false,
      },
      {
        behavior_uuid: "beha2f-4408-44ec-9fa4-db4b17fdbf60",
        name: "Harassment",
        is_active: false,
      },
      {
        behavior_uuid: "beha3f-4408-44ec-9fa4-db4b17fdbf60",
        name: "Sex",
        is_active: false,
      },
    ],
  },
  {
    workflow_config_uuid: "core-id",
    name: "Core Workflow",
    lookback: 48,
    sla_hours: 12,
    sources: [
      {
        blueprintItemSource_uuid: "bluee1-item-sour-9fa4-db4b17fdbf60",
        item_source_uuid: "itemsou1-4408-44ec-9fa4-db4b17fdbf60",
        name: "Magic Media",
        isActive: false,
      },
    ],
    item_types: [
      {
        blueprintItemType_uuid: "bluee1-item-type-9fa4-db4b17fdbf60",
        item_type_uuid: "itemtype1-4408-44ec-9fa4-db4b17fdbf60",
        name: "Trello",
        isActive: false,
      },
    ],
    behaviors: [
      {
        behavior_uuid: "beha4f-4408-44ec-9fa4-db4b17fdbf60",
        name: "Crime",
        is_active: false,
      },
      {
        behavior_uuid: "beha5f-4408-44ec-9fa4-db4b17fdbf60",
        name: "Violence",
        is_active: false,
      },
    ],
  },
];

function buildBlueprintInfoFromAnnotated(
  annotated: BlueprintAnnotatedApi
): BlueprintInfo {
  return {
    name: annotated.name,
    behaviors: annotated.behaviors.map((item) => ({
      behavior_uuid: item.external_id || "",
      name: item.name,
      isActive: item.is_active,
      media: item.media,
    })),
    sla_hours: 0,
    sources: annotated.sources.map((source) => ({
      blueprintItemSource_uuid: source.external_id || "",
      item_source_uuid: source.item_source_uuid,
      name: source.name,
      isActive: source.is_active,
    })),
    workflow_config_uuid: annotated.workflow_config_uuid || "",
    item_types: annotated.item_types.map((source) => ({
      blueprintItemType_uuid: source.external_id || "",
      item_type_uuid: source.item_type_uuid,
      name: source.name,
      isActive: source.is_active,
    })),
    lookback: 0,
    external_id: annotated.external_id,
  };
}

const blueprintInfoWithConfigList = blueprintsAnnotatedList.map((annotated) =>
  buildBlueprintInfoFromAnnotated(annotated)
);

function buildBlueprintInfoApiListMock(numItems: number): BlueprintInfo[] {
  const list: BlueprintInfo[] = [];

  for (let i = 1; i <= numItems; i++) {
    if (i >= 1 && i <= blueprintInfoWithConfigList.length) {
      list.push(blueprintInfoWithConfigList[i - 1]);
    } else {
      list.push({
        behaviors: [
          {
            behavior_uuid: "beha2f-4408-44ec-9fa4-db4b17fdbf60",
            name: "Cannabis",
            is_active: false,
          },
        ],
        sla_hours: 12,
        sources: [],
        item_types: [],
        lookback: 48,
        name: `My Blueprint ${i}`,
        external_id: `bluef${i}f-4408-44ec-9fa4-db4b17fdbf60`,
        workflow_config_uuid: `ed2b9c55-8644-437b-8289-102017350cfd`,
      });
    }
  }
  return list;
}

export async function getBlueprintInfoMock(
  blueprint_uuid: string
): Promise<BlueprintInfo> {
  const BlueprintInfo = blueprintInfoWithConfigList.find(
    (blueprint) => blueprint.external_id === blueprint_uuid
  );
  if (!BlueprintInfo) {
    throw new TypeError("Unexpected Exception");
  }
  return await buildMockPromise<BlueprintInfo>(BlueprintInfo);
}

export async function getAllBlueprintInfoMock(): Promise<
  BlueprintMinimalInfo[]
> {
  const numberOfMockedItems = 100;
  let result: BlueprintMinimalInfo[] = buildBlueprintInfoApiListMock(
    numberOfMockedItems
  ).map((blueprint) => ({
    blueprint_uuid: blueprint.external_id ?? "",
    name: blueprint.name ?? "",
    report_type: REPORT_TYPES.MISCONDUCT,
  }));
  return await buildMockPromise<BlueprintMinimalInfo[]>(result);
}

export async function getBlueprintInfoListMock(): Promise<BlueprintInfo[]> {
  const numberOfMockedItems = 10;
  let list = buildBlueprintInfoApiListMock(numberOfMockedItems);
  let result: BlueprintInfo[] = list;
  return await buildMockPromise<BlueprintInfo[]>(result);
}

export async function getWorkflowsBlueprintsListMock() {
  return await buildMockPromise<BlueprintInfo[]>(workflowsBlueprintsList);
}

export async function getReportTypesRootMock() {
  return await buildMockPromise<string[]>(["MISCONDUCT", "INSTANTFIT"]);
}
